import { useMemo } from 'react';

import type { Input } from '@/components/FilterButton/types';
import FilterTag from '@/components/FilterTag';

type Props = {
  filterConfig?: Record<string, Input>;
  params?: Record<string, string[]>;
  removeParam: (key: string) => void;
};

const useFilterTags = ({ filterConfig, params, removeParam }: Props) => {
  const optionValueMap = useMemo<Record<string, string>>(() => {
    const values: Record<string, string> = {};
    if (!filterConfig) return values;

    Object.values(filterConfig).forEach(inputConfig => {
      if (inputConfig.type === 'select' && inputConfig.options?.length) {
        inputConfig.options.forEach(option => {
          values[option.value] = option.label;
        });
      }
    });
    return values;
  }, [filterConfig]);

  const filterTagList = useMemo(() => {
    return Object.entries(params ?? {}).map(([name, value]) => (
      <FilterTag
        key={name}
        label={filterConfig?.[name]?.title}
        name={name}
        value={value}
        valueDictionary={optionValueMap}
        onClose={removeParam}
      />
    ));
  }, [filterConfig, optionValueMap, params, removeParam]);

  return { filterTagList };
};

export default useFilterTags;
